import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-video-validation"
export default class extends Controller {
  static targets = ["url", "duration", "thumbnailUrl", "validationError"]
  static values = {
    validateUrl: String
  }

  connect() {
    this.debounceTimeout = null
  }

  disconnect() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  validate() {
    // Clear any existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    const url = this.urlTarget.value.trim()

    if (url === "") {
      this.clearFields()
      this.clearValidationError()
      return
    }

    // Debounce the validation by 300ms
    this.debounceTimeout = setTimeout(() => {
      // Clear any existing validation error before performing new validation
      this.clearValidationError()
      this.performValidation(url)
    }, 300)
  }

  async performValidation(url) {
    try {
      const response = await fetch(this.validateUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ video_url: url })
      })

      const data = await response.json()

      if (data.valid) {
        this.setMetadataFields(data.video_info)
        this.clearValidationError()
      } else {
        this.clearFields()
        this.setValidationError(data.error || "Invalid video URL")
      }
    } catch (error) {
      console.error("Validation error:", error)
      this.clearFields()
      this.setValidationError("Error validating video URL")
    }
  }

  setMetadataFields(videoInfo) {
    if (this.hasDurationTarget) {
      this.durationTarget.value = videoInfo.duration || ""
    }
    if (this.hasThumbnailUrlTarget) {
      this.thumbnailUrlTarget.value = videoInfo.thumbnailUrl || ""
    }
  }

  clearFields() {
    if (this.hasDurationTarget) {
      this.durationTarget.value = ""
    }
    if (this.hasThumbnailUrlTarget) {
      this.thumbnailUrlTarget.value = ""
    }
  }

  setValidationError(errorMessage) {
    if (this.hasValidationErrorTarget) {
      this.validationErrorTarget.value = errorMessage
    }
  }

  clearValidationError() {
    if (this.hasValidationErrorTarget) {
      this.validationErrorTarget.value = ""
    }
  }
}
